// extracted by mini-css-extract-plugin
export default {"slider-wrapper":"Carousel_slider-wrapper__q-9ov","pagination-wrapper":"Carousel_pagination-wrapper__LOMqD","pagination-item":"Carousel_pagination-item__MdCuQ"};